import type React from "react";

import { LogOut, User } from "lucide-react";

import { useAuthActions } from "@/hooks/useAuthActions";
import { useCachedSession } from "@/hooks/useCachedSession";

const Header: React.FC = () => {
  const { data } = useCachedSession();
  const user = data?.data?.user;

  const { signOut } = useAuthActions();

  const logoutUser = async () => {
    await signOut();
  };

  return (
    <header className="flex items-center justify-between border-b bg-white px-6 py-4 shadow-sm">
      {/* Left side - empty for spacing */}
      <div />

      {/* Right side - User Profile */}
      <div className="flex items-center gap-2 text-gray-600">
        <User className="h-8 w-8 rounded-full bg-gray-200 p-1.5" />
        <div className="flex flex-col text-sm">
          <span className="font-medium">{user?.name}</span>
          <span className="text-gray-500">{user?.email}</span>
        </div>
        <div className="flex items-center gap-2">
          <LogOut
            className="h-6 w-6 cursor-pointer transition-all duration-200 hover:scale-110"
            onClick={logoutUser}
          />
        </div>
        {/* <ModeToggle className="h-6 w-6" />
        <LogOut className="h-6 w-6" /> */}
      </div>
    </header>
  );
};

export default Header;
